<template>
  <div class="billboard">
    <div class="billboard__wrapper">
      <Column align="center">
        <p class="billboard__title">Живешь в Томской области? Присоединяйся!</p>
        <p class="billboard__description">Знаете интересный маршрут или классные объекты, которых
          пока нет на карте проекта? Делитесь интересными фактами и объектами, оставляйте
          комментарии с подсказками и советами или предложите свою идею по развитию
          туризма в Томской области, - давайте развивать проект вместе!</p>
        <div class="billboard__buttons">
          <Button :class="$viewport.desktop ? 'rid-3' : ''"
                  :full="$viewport.mobile"
                  color="green"
                  v-on:click.native="$openPopupAddObject">Добавить объект
          </Button>
          <Button :class="$viewport.desktop ? 'rid-3' : ''"
                  :full="$viewport.mobile"
                  color="green"
                  v-on:click.native="$openPopupAddFact">Добавить факт
          </Button>
          <a
            :class="$viewport.desktop ? 'rid-3' : ''"
            href="https://act.tomsk.life/initiative#form"
            target="_blank"
          >
            <Button color="green" :full="$viewport.mobile">Добавить инициативу</Button>
          </a>
        </div>
      </Column>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Billboard',
};
</script>
